// 语言配置的返回默认值
export enum LangCodeDefault {
  zhCN = 'zh-CN', // 简体
  enUS = 'en-US', // 英文
  zhHK = 'zh-HK', // 繁体
  arSA = 'ar-SA', // 阿拉伯语
  msMY = 'ms-MY', // 阿拉伯语
}

// 中文简体
export const ZhCNLang = ['zh-CN'];

// 中文繁体
export const ZhHKLang = ['zh-HK', 'zh-TW'];

// 英文
export const EnLang = ['en', 'en-US', 'en-UK'];

// 阿拉伯语
export const ArLang = [
  'ar', // 阿拉伯语
  'ar-DZ', // 阿拉伯语 -阿尔及利亚
  'ar-BH', // 阿拉伯语 -巴林
  'ar-EG', // 阿拉伯语 -埃及
  'ar-IQ', // 阿拉伯语 -伊拉克
  'ar-JO', // 阿拉伯语 -约旦
  'ar-KW', // 阿拉伯语 -科威特
  'ar-LB', // 阿拉伯语 -黎巴嫩
  'ar-LY', // 阿拉伯语 -利比亚
  'ar-MA', // 阿拉伯语 -摩洛哥
  'ar-OM', // 阿拉伯语 -阿曼
  'ar-QA', // 阿拉伯语 -卡塔尔
  'ar-SA', // 阿拉伯语 - 沙特阿拉伯
  'ar-SY', // 阿拉伯语 -叙利亚共和国
  'ar-TN', // 阿拉伯语 -北非的共和国
  'ar-AE', // 阿拉伯语 - 阿拉伯联合酋长国
  'ar-YE', // 阿拉伯语 -也门
];

// 马来语
export const MsMyLang = ['ms', 'ms-BN', 'ms-MY'];

// 暴露给外部配置
export const LangKeys = {
  zhCN: 'zhCN', // 中文，简体
  zhHK: 'zhHK', // 中文 繁体
  enUS: 'enUS', // 英文
  arSA: 'arSA', // 阿拉伯语言
  msMy: 'msMy', // 马来语
};

// 默认语言
export const langConfig = {
  [LangKeys.zhCN]: ZhCNLang,
  [LangKeys.zhHK]: ZhHKLang,
  [LangKeys.enUS]: EnLang,
  [LangKeys.arSA]: ArLang,
  [LangKeys.msMy]: MsMyLang,
};
